import { Box, Typography, Checkbox } from "@mui/material";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import theme from "../../configs/theme";

export default function ActivityItem({ activity, showCheckbox, selected, onSelect }) {
  const isIngreso = activity.operation === "Ingresos";
  const sign = isIngreso ? "+" : "-";
  const amountColor = isIngreso ? "green" : "black"

  const Icon =
    activity.operation === "Compras"
      ? ShoppingCartIcon
      : activity.operation === "Pagos"
      ? MoneyOffIcon
      : AttachMoneyIcon;

  return (
    <Box
      sx={{
        width: "auto",
        height: "10vh",
        display: "flex",
        alignContent: "center",
        py: 1,
        px: 2,
        flexDirection: "row",
        "&:hover": {
          backgroundColor: theme.hoverColors.body,
        },
      }}
    >
      {/* Icono redondo y centrado */}
      <Box
        sx={{
          width: 60,
          height: 60,
          borderRadius: "50%",
          bgcolor: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mr: 2,
        }}
      >
        <Icon sx={{ fontSize: 35 }} />
      </Box>

      {/* Info */}
      <Box
        sx={{
          flexGrow: 1,
        }}      
      >
        <Typography fontWeight={"bold"}>{activity.title}</Typography>
        <Typography mt={2}>
          Operación: {activity.operation}
          {activity.description && ` - ${activity.description}`}
        </Typography>
      </Box>

      {/* Amount alineado a la derecha */}
      <Typography 
        sx={{ 
          color: amountColor, 
          fontWeight: "bold", 
          alignContent: "center", 
        }}
      >
        {sign}${activity.amount}
      </Typography>

      {showCheckbox && (
        <Checkbox
          checked={selected}
          onChange={() => onSelect(activity.id)}
        />
      )}
    </Box>
  );
}
